import ChargeIdentifierListView from '../../components/ChargeIdentifierListView';

function ChargeIdentifierListScreen(props) {
  return (
    <div className="container-fluid px-4 my-4">
      <ChargeIdentifierListView />
    </div>
  );
}

export default ChargeIdentifierListScreen;
